import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './SellerFAQPage.css';

const SellerFAQPage = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqData = [
    {
      question: "What's included in a standard home cleaning?",
      answer: "Dusting, vacuuming, mopping, kitchen/bathroom sanitization, trash removal, and surface wiping. Add-ons (like fridge cleaning) available. Dusting, vacuuming, mopping, kitchen/bathroom sanitization, trash removal, and surface wiping. Add-ons (like fridge cleaning) available."
    },
    {
      question: "What's included in a standard home cleaning?",
      answer: "Dusting, vacuuming, mopping, kitchen/bathroom sanitization, trash removal, and surface wiping. Add-ons (like fridge cleaning) available."
    },
    {
      question: "What's included in a standard home cleaning?",
      answer: "Dusting, vacuuming, mopping, kitchen/bathroom sanitization, trash removal, and surface wiping. Add-ons (like fridge cleaning) available."
    },
    {
      question: "What's included in a standard home cleaning?",
      answer: "Dusting, vacuuming, mopping, kitchen/bathroom sanitization, trash removal, and surface wiping. Add-ons (like fridge cleaning) available."
    },
    {
      question: "What's included in a standard home cleaning?",
      answer: "Dusting, vacuuming, mopping, kitchen/bathroom sanitization, trash removal, and surface wiping. Add-ons (like fridge cleaning) available."
    },
    {
      question: "What's included in a standard home cleaning?",
      answer: "Dusting, vacuuming, mopping, kitchen/bathroom sanitization, trash removal, and surface wiping. Add-ons (like fridge cleaning) available."
    },
    {
      question: "What's included in a standard home cleaning?",
      answer: "Dusting, vacuuming, mopping, kitchen/bathroom sanitization, trash removal, and surface wiping. Add-ons (like fridge cleaning) available."
    },
    {
      question: "What's included in a standard home cleaning?",
      answer: "Dusting, vacuuming, mopping, kitchen/bathroom sanitization, trash removal, and surface wiping. Add-ons (like fridge cleaning) available."
    },
    {
      question: "What's included in a standard home cleaning?",
      answer: "Dusting, vacuuming, mopping, kitchen/bathroom sanitization, trash removal, and surface wiping. Add-ons (like fridge cleaning) available."
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  const ArrowUpIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.9729 15.4652C4.96833 15.673 5.02857 15.8771 5.14534 16.0491C5.2621 16.221 5.42963 16.3523 5.62447 16.4247C5.81931 16.4971 6.03183 16.507 6.23255 16.453C6.43327 16.399 6.6121 16.2838 6.74432 16.1234L11.9865 10.0043L17.2268 16.1234C17.3084 16.2344 17.4119 16.3273 17.531 16.3963C17.6501 16.4654 17.7822 16.5091 17.919 16.5248C18.0558 16.5404 18.1943 16.5277 18.3259 16.4873C18.4576 16.4469 18.5795 16.3798 18.684 16.2901C18.7884 16.2005 18.8732 16.0902 18.9331 15.9663C18.993 15.8423 19.0266 15.7073 19.0319 15.5697C19.0372 15.4321 19.0142 15.2949 18.964 15.1667C18.9138 15.0385 18.8377 14.922 18.7405 14.8246L12.7463 7.81875C12.6524 7.70873 12.5358 7.62038 12.4045 7.5598C12.2732 7.49922 12.1302 7.46785 11.9856 7.46785C11.8409 7.46785 11.698 7.49922 11.5667 7.5598C11.4353 7.62038 11.3187 7.70873 11.2248 7.81875L5.22481 14.8246C5.06761 15.0016 4.97847 15.2286 4.9729 15.4652Z" fill="#0F0F0F"/>
    </svg>
  );

  const ArrowDownIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.031 8.53477C19.0356 8.32697 18.9753 8.12291 18.8586 7.95095C18.7418 7.779 18.5743 7.64769 18.3794 7.5753C18.1846 7.50291 17.9721 7.49302 17.7714 7.54701C17.5706 7.60101 17.3918 7.7162 17.2596 7.87657L12.0174 13.9957L6.77707 7.87657C6.69554 7.76563 6.59202 7.67272 6.47291 7.60366C6.35381 7.5346 6.22169 7.49088 6.0849 7.47523C5.94812 7.45958 5.8096 7.47234 5.67798 7.51272C5.54635 7.55309 5.42444 7.62021 5.31996 7.70987C5.21547 7.79952 5.13072 7.90978 5.07082 8.03375C5.01092 8.15772 4.97728 8.29272 4.97197 8.43029C4.96666 8.56787 4.98974 8.70506 5.03991 8.83327C5.09007 8.96148 5.16617 9.07796 5.26344 9.1754L11.2576 16.1813C11.3515 16.2913 11.4681 16.3796 11.5994 16.4402C11.7307 16.5008 11.8737 16.5322 12.0183 16.5322C12.163 16.5322 12.3059 16.5008 12.4373 16.4402C12.5686 16.3796 12.6852 16.2913 12.7791 16.1813L18.7791 9.1754C18.9363 8.99842 19.0254 8.77142 19.031 8.53477Z" fill="#0F0F0F"/>
    </svg>
  );

  return (
    <div className="seller-faq-page">
      <Header />
      
      <main className="seller-faq-main">
        {/* Hero Section */}
        <section className="seller-faq-hero">
          <h1 className="seller-faq-title">Frequently Asked Questions</h1>
        </section>

        {/* FAQ Section */}
        <section className="seller-faq-content">
          <div className="faq-container">
            <div className="faq-questions-list">
              {faqData.map((faq, index) => (
                <div 
                  key={index} 
                  className={`faq-question-container ${openIndex === index ? 'active' : ''}`}
                >
                  <div 
                    className="faq-question"
                    onClick={() => toggleFaq(index)}
                  >
                    <div className="faq-question-text">
                      <span className={openIndex === index ? 'question-bold' : ''}>
                        {faq.question}
                      </span>
                    </div>
                    <div className="faq-arrow">
                      {openIndex === index ? <ArrowUpIcon /> : <ArrowDownIcon />}
                    </div>
                  </div>
                  {openIndex === index && (
                    <div className="faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default SellerFAQPage;
